import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IClient, IClientInitialState } from "./clientModel";
import { ActiveInactiveClient, ClientImageUpload, createClient, deleteClient, getAllActiveClient, getAllClient, getClientByID, updateClient } from "./services/client.services";


const initialState: IClientInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ClientList: [],
  ClientID: null,
  ClientDetail: {
    ClientName: "",
    IsActive: 1,
  },
};

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    clearClientDetail: (state) => {
      state.ClientDetail = initialState.ClientDetail;
    },
    setClientID: (state, action) => {
      state.ClientID = action.payload;
    },
    clearClientID: (state) => {
      state.ClientID = initialState.ClientID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllClient.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllClient.fulfilled,
      (state, action: PayloadAction<IClient[]>) => {
        state.loading = false;
        state.ClientList = action.payload || [];
      }
    );
    builder.addCase(getAllClient.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ClientList = [];
    });
    builder.addCase(createClient.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createClient.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createClient.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateClient.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateClient.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateClient.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteClient.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteClient.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteClient.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getClientByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getClientByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ClientDetail = action.payload;
    });
    builder.addCase(getClientByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ClientDetail = initialState.ClientDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveClient.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveClient.fulfilled,
      (state, action: PayloadAction<IClient[]>) => {
        state.loading = false;
        state.ClientList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveClient.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ClientList = [];
    });
    builder.addCase(ActiveInactiveClient.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveClient.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveClient.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(ClientImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ClientImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ClientImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearClientDetail ,clearClientID,setClientID } =
  clientSlice.actions;
export default clientSlice.reducer;
